import request from '@/router/axios'

export function adminEditReward (obj) {
    return request({
      url: '/admin/reward-record/add',
      method: 'post',
      data: obj
    })
}

export function getRewardRecordList (query,memberId) {
    return request({
      url: '/admin/reward-record/detail/' + memberId,
      method: 'get',
      params: query
    })
}